import { render } from "./HeroiconsOutlineChatAlt2.vue?vue&type=template&id=7fd74d7c"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChatAlt2.vue"]])

export default __exports__